'use client';

import './styles/default.scss';
import { getText } from '@/utils/text/text';
import { useSessionTimers } from '@/hooks/use-session-timers';
import { useStore } from '@/store/store';
import dayjs from 'dayjs';
import type { FC } from 'react';
import { useGlobalContext } from '@/store/contexts/global-context';

export const SessionTimers: FC = () => {
    const { isLoggedIn } = useGlobalContext();
    const lastLogin = useStore((state) => state.userContext?.session?.lastLogin);
    const sessionStartTime = useStore((state) => state.userContext?.session?.sessionStartTime);
    const { sessionTime } = useSessionTimers({ sessionStartTime });

    if (!isLoggedIn) {
        return null;
    }

    return (
        <p data-testid="session-timers" className="session-timers">
            <span>
                {getText({ text: 'common.lastLogin' })}:{' '}
                {!!lastLogin ? dayjs(lastLogin).format(getText({ text: 'common.lastLoginDateFormatHeader' })) : '-'}
            </span>
            <span>
                {getText({ text: 'common.sessionTime' })}: {sessionTime}
            </span>
        </p>
    );
};
